import { createReducer, on } from '@ngrx/store';
import { setTimeEntryGridConfig, clearTimeEntryGridConfig } from './timeEntryGridConfig.actions';
import { initialTimeEntryGridConfigModel } from './timeEntryGridConfig.state';

export const timeEntryGridConfigReducer = createReducer(
    initialTimeEntryGridConfigModel ,
    on(setTimeEntryGridConfig, (state, { timeEntryGridConfig }) => ({ ...state, timeEntryGridConfig : timeEntryGridConfig })),
    on(clearTimeEntryGridConfig, state => ({ ...state, timeEntryGridConfig : null }))
);